// extracted by mini-css-extract-plugin
export default {"tabBackground":"fVINuDQ1sg3rFLynMxWm7Q==","tabTextStyle":"amlg2lQpZgsv0Xf8VT6Orw==","tabTextStyleDisabled":"TXe9LD0Ckj4fFzWDrhOnCQ=="};